import { render } from "./AddPublisherWebsiteModal.vue.js?vue&type=template&id=16167cd6!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AddPublisherWebsiteModal.vue?vue&type=template&id=16167cd6"
import script from "./AddPublisherWebsiteModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AddPublisherWebsiteModal.vue?vue&type=script&lang=js"
export * from "./AddPublisherWebsiteModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AddPublisherWebsiteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publisher-websites/AddPublisherWebsiteModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16167cd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16167cd6', __exports__)) {
    api.reload('16167cd6', __exports__)
  }
  
  module.hot.accept("./AddPublisherWebsiteModal.vue.js?vue&type=template&id=16167cd6!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AddPublisherWebsiteModal.vue?vue&type=template&id=16167cd6", () => {
    api.rerender('16167cd6', render)
  })

}


export default __exports__